'use strict';

export function init(){
    setTimeout(function(){
        let button = $('[data-bv-show="rating_summary"]');
        if(button){
            button.on('click', function() {
                let $rating = $('#nav-tab-productratings');
                $rating.tab('show');
                let scrollRating = $rating[0].getBoundingClientRect().top + window.scrollY - 200;
                window.scroll({
                    top: scrollRating,
                    behavior: 'smooth'
                });
            });

            button.on('mouseover', function() {
                let readButton = $('.bv_button_buttonFull');
                if(readButton){
                    readButton.on('click', function() {
                        let $rating = $('#nav-tab-productratings');
                        $rating.tab('show');
                        let scrollRating = $rating[0].getBoundingClientRect().top + window.scrollY - 200;
                        window.scroll({
                            top: scrollRating,
                            behavior: 'smooth'
                        });
                    });
                }
            });
        }
    }, 1000);
}